module.exports = __webpack_public_path__ + "img/logo-ocean-plus-habitats.9d769183.svg";